import { IAdditionalTask, IProduct } from "../../fetchOrderProducts";

export function isAdditionalTask(
  product: IProduct,
): product is IAdditionalTask {
  return (
    "specificationId" in product && product.specificationId === "ADDITIONALTASK"
  );
}
